import { render, staticRenderFns } from "./continueWatchingPlaceholder.vue?vue&type=template&id=68cb5b41"
import script from "./continueWatchingPlaceholder.vue?vue&type=script&lang=js"
export * from "./continueWatchingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./continueWatchingPlaceholder.vue?vue&type=style&index=0&id=68cb5b41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports